export default {
    _bpreplaybold: 'bpreplaybold',
    _bpreplayregular: 'bpreplayregular',
}